import React from 'react';

const InitialsBadge = ({ 
  name, 
  size = 'md', 
  className = '',
}) => {
  // Extract initials from name
  const getInitials = (fullName) => {
    if (!fullName) return '??';
    
    const names = fullName.trim().split(' ');
    if (names.length === 1) {
      return names[0].substring(0, 2).toUpperCase();
    }
    
    return names
      .slice(0, 2)
      .map(name => name.charAt(0))
      .join('')
      .toUpperCase();
  };

  // Generate consistent premium gradient based on name (using inline styles for reliability)
  const getGradientStyle = (name) => {
    const gradients = [
      'linear-gradient(135deg, #6366f1 0%, #9333ea 100%)', // indigo to purple
      'linear-gradient(135deg, #fb923c 0%, #f43f5e 100%)', // orange to rose
      'linear-gradient(135deg, #34d399 0%, #0d9488 100%)', // emerald to teal
      'linear-gradient(135deg, #3b82f6 0%, #4338ca 100%)', // blue to indigo
      'linear-gradient(135deg, #fbbf24 0%, #ea580c 100%)', // amber to orange
      'linear-gradient(135deg, #ec4899 0%, #f43f5e 100%)', // pink to rose
      'linear-gradient(135deg, #8b5cf6 0%, #d946ef 100%)', // violet to fuchsia
      'linear-gradient(135deg, #38bdf8 0%, #2563eb 100%)', // sky to blue
      'linear-gradient(135deg, #06b6d4 0%, #2563eb 100%)', // cyan to blue
      'linear-gradient(135deg, #fb7185 0%, #dc2626 100%)', // rose to red
    ];
    
    if (!name) return gradients[0];
    
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    
    return gradients[Math.abs(hash) % gradients.length];
  };

  // Size configurations
  const sizeConfig = {
    xs: { container: 'w-6 h-6', text: 'text-[10px]' },
    sm: { container: 'w-8 h-8', text: 'text-xs' },
    md: { container: 'w-10 h-10', text: 'text-sm' },
    lg: { container: 'w-12 h-12', text: 'text-base' },
    xl: { container: 'w-16 h-16', text: 'text-lg' },
    '2xl': { container: 'w-20 h-20', text: 'text-2xl' }
  };

  const initials = getInitials(name);
  const gradientStyle = getGradientStyle(name);
  const sizeClasses = sizeConfig[size] || sizeConfig.md;

  return (
    <div 
      className={`
        ${sizeClasses.container} 
        text-white
        ${sizeClasses.text}
        rounded-full 
        flex 
        items-center 
        justify-center 
        font-bold 
        select-none
        shadow-sm
        ${className}
      `}
      style={{ background: gradientStyle }}
      title={name}
    >
      {initials}
    </div>
  );
};

export default InitialsBadge;

